/** Canonical path for the authenticated hacker dashboard entry (application + RSVP). */
export const HACKER_PORTAL_PATH = "/hacker-portal";
